import { gql } from '@apollo/client';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useGetAuthorsForSelectorQuery } from 'lib/graphql-generated';

const GET_AUTHOR_NAMES = gql`
  query GetAuthorsForSelector {
    booksellers {
      id
      name
    }
  }
`;

export interface BooksellerSelectorValue {
  name: string;
  id: number;
}

export const DefaultBooksellerSelectorValue: BooksellerSelectorValue = {
  id: -1,
  name: 'Select a Bookseller',
};

interface Props {
  value: BooksellerSelectorValue;
  setValue: Dispatch<SetStateAction<BooksellerSelectorValue>>;
  lateInitWithId?: number;
  label: string;
  id?: string;
  disabled?: boolean;
  className?: string;
}

export const BooksellerSelect = ({
  value,
  setValue,
  lateInitWithId,
  label,
  disabled = false,
  id,
  className,
}: Props) => {
  const [sellers, setSellers] = useState<BooksellerSelectorValue[]>([]);
  const { data, networkStatus } = useGetAuthorsForSelectorQuery({
    fetchPolicy: 'cache-and-network',
  });
  const innerId = id ? id : 'booksellerSelector';

  useEffect(() => {
    if (data?.booksellers.length > 0) {
      setSellers(data.booksellers);
    }
  }, [data]);

  return (
    <label
      htmlFor={innerId}
      className={`${className} text-sm font-medium text-gray-700`}>
      {label && label}
      <select
        className='mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-default focus:border-green-default sm:text-sm rounded-md'
        name={innerId}
        id={innerId}
        value={value.id}
        onChange={(e) =>
          setValue(sellers.find((v) => v.id === parseInt(e.target.value)))
        }>
        <option value={DefaultBooksellerSelectorValue.id} disabled>
          {DefaultBooksellerSelectorValue.name}
        </option>
        {sellers.map((author) => (
          <option key={`author_${author.id}`} value={author.id}>
            {author.name}
          </option>
        ))}
      </select>
    </label>
  );
};
